/**
 * Created by vsuthar on 9/15/21
 * File: CombineReducer
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

import TreeReducer from './TreeReducer'
import ViewReducer from './ViewReducer'
import IAMReducer from './IAMReducer'
import LicenseReducer from './LicenseReducer'
import AppReducer from './AppReducer'
import SubscriptionReducer from './SubscriptionReducer'

/**
 *
 * @type {{treeReducer: {flattenTree: [], sgTree: [], sgKeyBy: {}, breadcrumbs: Map<unknown, unknown>}, viewReducer: {currentView: string, isGlobalModuleOpen: boolean}, instanceReducer: {instances: []}}}
 */
const initialState = {
  treeReducer: TreeReducer.initialState,
  viewReducer: ViewReducer.initialState,
  iamReducer: IAMReducer.initialState,
  licenseReducer: LicenseReducer.initialState,
  appReducer: AppReducer.initialState,
  subscriptionReducer: SubscriptionReducer.initialState,
}

/**
 * Combine all reducer into single Reducer and can be accessible via key for each reducer mention in initialState
 * @param reducers
 * @returns {function(*=, *=): {}}
 */
const combineReducers = reducers => {
  return (state = {}, action) => {
    const newState = {}
    for (const key in reducers) {
      newState[key] = reducers[key](state[key], action)
    }
    return newState
  }
}

export { initialState, combineReducers }

